/**
 * Created by Jerker Nord on 2023-10-07.
 */
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {SimplePresentation, SimplePresentationRunner} from "../../../core/winpresentation/SimplePresentationRunner";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {
   LonerTickTickBoomOutroPresentation
} from "../../presentationrunners/features/ticktickboom/LonerTickTickBoomOutroPresentation";

export class LonerTickTickBoomWinTrigger implements FlowStatePresentation{

   protected _presentations:SimplePresentation[];

   constructor() {
      this._presentations = [
         new LonerTickTickBoomOutroPresentation()
      ];
   }

   public start(flowStateController:FlowStateController):void {
      SimplePresentationRunner.run(this._presentations, () => flowStateController.finish(), (callback?:Function) => flowStateController.setSkipCallback(callback));
   }
}